import styled from "styled-components";

export const ContainerEnviarOrden = styled.div`
  width: 359px;
  height: 480px;
`;

export const TopEnviarOrden = styled.div`
  width: 100%;
  height: 67px;
  background: var(--color-secondary-gradient);
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  color: var(--color-white);
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const BodyEnviarOrden = styled.div`
  width: 100%;
  height: calc(100% - 67px);
  padding-top: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  .tituloDatos {
    margin-bottom: 8px;
    text-align: center;
  }
  @media (max-height: 700px) {
    height: 500px;
    gap: 16px;
    padding-top: 30px;
  }
`;

export const InputContainer = styled.div`
  width: 80%;
  .iconoTextoContainer {
    display: flex;
    align-items: center;
    gap: 6px;
  }
`;

export const ModalHeaderCross = styled.div`
  right: 32px;
  top: 16px;
  position: absolute;
  display: block;
  height: 16px;
  width: 16px;
  &:hover {
    cursor: pointer;
  }
`;

export const ModalHeaderCrossX = styled.div`
  border: 1px solid #fff;
  height: 20px;
  transform: rotate(45deg);
  width: 0px;
  background: #fff;
  position: absolute;
  left: 8px;
`;

export const ModalHeaderCrossY = styled.div`
  border: 1px solid #fff;
  height: 20px;
  transform: rotate(-45deg);
  width: 0px;
  background: #fff;
  position: absolute;
  left: 8px;
`;
export const BtnSubirOrden = styled.button`
  border-radius: 8px;
  width: 80%;
  height: 42px;
  @media (max-height: 700px) {
    margin-top: -16px;

  }
`;
